import React, { useEffect, useCallback, useState, useRef } from 'react';
import { useLocation, history, useDispatch } from 'umi';
import {} from '@material-ui/core';
import qs from 'qs';
import dayjs from 'dayjs';
import ResultList from './components/result_list/ResultList';
import SearchGroup from './components/search_group/SearchGroup';
import MyTaskStyled from './myTaskStyles';

export default () => {
  const sevenAfterDate = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
  const today = dayjs().format('YYYY-MM-DD');
  const dispatch = useDispatch();
  const location = useLocation();
  const { query, pathname } = location;
  const [isSearch, setIsSearch] = useState(false);
  const searchRef = useRef();
  // 结构到所有查询条件，包括分页条件
  const {
    startDate = sevenAfterDate,
    endDate = today,
    status = null,
    taskName = null,
    refreshTime,
    pageNum = '1',
    pageSize = '10',
  } = query;

  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        refreshTime: time,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: 1,
      })}`,
    );
  };
  //活动列表
  const fetchMailTemplateList = useCallback(() => {
    const values = {
      startTime: startDate ? `${startDate} 00:00:00` : null,
      endTime: endDate ? `${endDate} 23:59:59` : null,
      status: status || null,
      taskName: taskName || null,
      pageNum,
      pageSize,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'myTask/getTaskList',
      payload: {
        values,
      },
    });
  }, [
    dispatch,
    pageNum,
    pageSize,
    refreshTime,
    endDate,
    startDate,
    status,
    taskName,
  ]);

  useEffect(() => {
    fetchMailTemplateList();
  }, [fetchMailTemplateList]);

  return (
    <MyTaskStyled>
      <div
        data-log={JSON.stringify({
          oid: 'page_my_task',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
      >
        <SearchGroup
          searchRef={searchRef}
          query={query}
          handleSearch={(searchParam) => handleSearch(searchParam)}
          restClick={handleRestClick}
        />
        <ResultList
          pageData={{ pageNum, pageSize }}
          handlePageChange={handlePageChange}
        />
      </div>
    </MyTaskStyled>
  );
};
